export enum OnboardingCaseEnum {
    AddTrades = 'addTrades',
}
